<div class="container-fluid">

    <app-personal-list [datas]="datas" [vue]="vue"></app-personal-list>
</div>